import * as types from "state/entities/subscriptions/subscriptionsTypes";

export const initState = {
  pages: {},
  detailedIds: {},
  totalCount: null
};

const api = (state = initState, action) => {
  switch (action.type) {
    case types.FETCH_SUBSCRIPTIONS: {
      const page = {
        [action.request.page]: {
          ...state.pages[action.request.page],
          isFetching: true
        },
        lastFetched: Date.now()
      };

      return {
        ...state,
        pages: { ...state.pages, ...page }
      };
    }

    case types.FETCH_SUBSCRIPTIONS_SUCCESS: {
      const {
        request: { page },
        response: { ids }
      } = action;
      const pages = {
        ...state.pages,
        [page]: {
          isFetching: false,
          ids: ids,
          didInvalidate: false,
          lastFetched: Date.now()
        }
      };

      return {
        ...state,
        pages: pages
      };
    }

    default:
      return state;
  }
};

export default api;
